function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { inputRules, InputRule } from 'prosemirror-inputrules';
import { applyMarkOnRange } from '../commands';
import { createInputRule } from '../utils';
import { TextSelection } from 'prosemirror-state';
var validCombos = {
  '**': ['_', '~~', '^'],
  '*': ['__', '~~', '^'],
  '^': ['*', '_'],
  __: ['*', '~~', '^'],
  _: ['**', '~~', '^'],
  '~~': ['__', '_', '**', '*', '^']
};

var validRegex = function validRegex(char, str) {
  for (var i = 0; i < validCombos[char].length; i++) {
    var ch = validCombos[char][i];

    if (ch === str) {
      return true;
    }

    var matchLength = str.length - ch.length;

    if (str.substr(matchLength, str.length) === ch) {
      return validRegex(ch, str.substr(0, matchLength));
    }
  }

  return false;
};

function addMark(markType, schema, charSize, char) {
  return function (state, match, start, end) {
    var _match = _slicedToArray(match, 3),
        prefix = _match[1],
        textWithCombo = _match[2];

    var to = end; // in case of *string* pattern it matches the text from beginning of the paragraph,
    // because we want ** to work for strong text
    // that's why "start" argument is wrong and we need to calculate it ourselves

    var from = textWithCombo ? start + prefix.length : start;
    var nodeBefore = state.doc.resolve(start + prefix.length).nodeBefore;

    if (prefix && prefix.length > 0 && !validRegex(char, prefix) && !(nodeBefore && nodeBefore.type === state.schema.nodes.hard_break)) {
      return null;
    } // fixes the following case: my `*name` is *
    // expected result: should ignore special characters inside "code"


    if (state.schema.marks.code && state.schema.marks.code.isInSet(state.doc.resolve(from + 1).marks())) {
      return null;
    } // Prevent autoformatting across hardbreaks


    var containsHardBreak;
    state.doc.nodesBetween(from, to, function (node) {
      if (node.type === schema.nodes.hard_break) {
        containsHardBreak = true;
        return false;
      }

      return !containsHardBreak;
    });

    if (containsHardBreak) {
      return null;
    } // fixes autoformatting in heading nodes: # Heading *bold*
    // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>


    if (state.doc.resolve(from).sameParent(state.doc.resolve(to))) {
      if (!state.doc.resolve(from).parent.type.allowsMarkType(markType)) {
        return null;
      }
    } // apply mark to the range (from, to)


    var tr = state.tr.addMark(from, to, markType.create());

    if (charSize > 1) {
      // delete special characters after the text
      // Prosemirror removes the last symbol by itself, so we need to remove "charSize - 1" symbols
      tr = tr.delete(to - (charSize - 1), to);
    }

    return tr // delete special characters before the text
    .delete(from, from + charSize).removeStoredMark(markType);
  };
}

function addCodeMark(markType, specialChar) {
  return function (state, match, start, end) {
    if (match[1] && match[1].length > 0) {
      var allowedPrefixConditions = [function (prefix) {
        return prefix === '(';
      }, function (prefix) {
        var nodeBefore = state.doc.resolve(start + prefix.length).nodeBefore;
        return nodeBefore && nodeBefore.type === state.schema.nodes.hard_break || false;
      }];

      if (allowedPrefixConditions.every(function (condition) {
        return !condition(match[1]);
      })) {
        return null;
      }
    } // fixes autoformatting in heading nodes: # Heading `bold`
    // expected result: should not autoformat *bold*; <h1>Heading `bold`</h1>


    if (state.doc.resolve(start).sameParent(state.doc.resolve(end))) {
      if (!state.doc.resolve(start).parent.type.allowsMarkType(markType)) {
        return null;
      }
    }

    var tr = state.tr; // checks if a selection exists and needs to be removed

    if (state.selection.from !== state.selection.to) {
      tr.delete(state.selection.from, state.selection.to);
      end -= state.selection.to - state.selection.from;
    }

    var regexStart = end - match[2].length + 1;
    var codeMark = state.schema.marks.code.create();
    return applyMarkOnRange(regexStart, end, false, codeMark, tr).setStoredMarks([codeMark]).delete(regexStart, regexStart + specialChar.length).removeStoredMark(markType);
  };
}

export var strongRegex1 = /(\S*)(\_\_([^\_\s](\_(?!\_)|[^\_])*[^\_\s]|[^\_\s])\_\_)$/;
export var strongRegex2 = /(\S*)(\*\*([^\*\s](\*(?!\*)|[^\*])*[^\*\s]|[^\*\s])\*\*)$/;
export var italicRegex1 = /(\S*[^\s\_]*)(\_([^\s\_][^\_]*[^\s\_]|[^\s\_])\_)$/;
export var italicRegex2 = /(\S*[^\s\*]*)(\*([^\s\*][^\*]*[^\s\*]|[^\s\*])\*)$/;
export var strikeRegex = /(\S*)(\~\~([^\s\~](\~(?!\~)|[^\~])*[^\s\~]|[^\s\~])\~\~)$/;
export var codeRegex = /(\S*)(`[^\s][^`]*`)$/;
export var supertextRegex = /(\S*[^\s^]*)(\^([^\s^][^^]*[^\s^]|[^\s^])\^)$/;
/**
 * Create input rules for strong mark
 *
 * @param {Schema} schema
 * @returns {InputRule[]}
 */

function getStrongInputRules(schema) {
  // **string** or __strong__ should bold the text
  var markLength = 2;
  var doubleUnderscoreRule = createInputRule(strongRegex1, addMark(schema.marks.strong, schema, markLength, '__'));
  var doubleAsterixRule = createInputRule(strongRegex2, addMark(schema.marks.strong, schema, markLength, '**'));
  return [doubleUnderscoreRule, doubleAsterixRule];
}
/**
 * Create input rules for em mark
 *
 * @param {Schema} schema
 * @returns {InputRule[]}
 */


function getItalicInputRules(schema) {
  // *string* or _string_ should italic the text
  var markLength = 1;
  var underscoreRule = createInputRule(italicRegex1, addMark(schema.marks.em, schema, markLength, '_'));
  var asterixRule = createInputRule(italicRegex2, addMark(schema.marks.em, schema, markLength, '*'));
  return [underscoreRule, asterixRule];
}
/**
 * Create input rules for strike mark
 *
 * @param {Schema} schema
 * @returns {InputRule[]}
 */


function getStrikeInputRules(schema) {
  var markLength = 2;
  var doubleTildeRule = createInputRule(strikeRegex, addMark(schema.marks.strike, schema, markLength, '~~'));
  return [doubleTildeRule];
}

function getSuperscriptInputRules(schema) {
  var markLength = 1; // const doubleTildeRule = addMark(schema.marks.superscript);

  var doubleTildeRule = createInputRule(supertextRegex, addMark(schema.marks.superscript, schema, markLength, '^'));
  return [doubleTildeRule];
}
/**
 * Create input rules for code mark
 *
 * @param {Schema} schema
 * @returns {InputRule[]}
 */


function getCodeInputRules(schema) {
  var backTickRule = createInputRule(codeRegex, addCodeMark(schema.marks.code, '`'));
  return [backTickRule];
}

export function textFormattingInputRules(schema) {
  var rules = [];

  if (schema.marks.strong) {
    rules.push.apply(rules, _toConsumableArray(getStrongInputRules(schema)));
  }

  if (schema.marks.em) {
    rules.push.apply(rules, _toConsumableArray(getItalicInputRules(schema)));
  }

  if (schema.marks.superscript) {
    rules.push.apply(rules, _toConsumableArray(getSuperscriptInputRules(schema)));
  }

  if (schema.marks.strike) {
    rules.push.apply(rules, _toConsumableArray(getStrikeInputRules(schema)));
  }

  if (schema.marks.code) {
    rules.push.apply(rules, _toConsumableArray(getCodeInputRules(schema)));
  }

  if (rules.length !== 0) {
    return inputRules({
      rules: rules
    });
  }

  return;
}
export default textFormattingInputRules;